import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation joinGroup($groupId: String!, $inviteToken: String) {
    joinGroup(groupId: $groupId, inviteToken: $inviteToken) {
      group {
        id
        name
      }
    }
  }
`

export interface JoinGroupInput {
  groupId: string
  inviteToken?: string
}

export interface JoinGroupOutput {
  joinGroup: {
    group: {
      id: string
      name: string
    }
  }
}

export const useJoinGroup = () => useMutation<JoinGroupOutput, JoinGroupInput>(mutation)
